module.exports = __webpack_public_path__ + "static/media/threats-en.4f6089bb.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/threats-en.mp4
// module id = 287
// module chunks = 0